import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'

import { Box, Flex } from '@chakra-ui/react'

import { CreateDropdown } from '@/components/layouts/CreateDropdown'
import { GlobalEmergencyCallButton } from '@/features/emergency-call'
import { MixpanelDataIProps } from '@/features/incident-drawer'

interface ActionButtonsIProps {
  mixpanelData?: MixpanelDataIProps
  emergencyCallVariant?: string
  createDropdownVariant?: string
}

/**
 * ActionButtons - Renders emergency call and create dropdown buttons
 * Used in page headers across the application
 */

export const ActionButtons = ({
  mixpanelData,
  emergencyCallVariant,
  createDropdownVariant,
}: ActionButtonsIProps) => {
  return (
    <Flex
      align='center'
      data-testid='action-buttons'
      direction='row'
      gap={4}
      justify='start'
    >
      {useFeatureFlag(FeatureFlag.emergencyCall) && (
        <GlobalEmergencyCallButton
          data-testid='action-buttons-emergency-call'
          mixpanelData={mixpanelData}
          variant={emergencyCallVariant}
        />
      )}

      <Box data-testid='action-buttons-create-dropdown'>
        <CreateDropdown variant={createDropdownVariant} />
      </Box>
    </Flex>
  )
}
